const facebookRevenueCalculationMiddleware = ({ payload, next }) => {
    if (!payload || !payload.obj || !payload.obj.event) {
        next(payload);
        return;
    }

    payload.obj.properties = payload.obj.properties || {};

    const obj = payload.obj;

    if (obj.event != 'Order Completed') {
        next(payload);
        return;
    }

    try {
        const revenue = obj.properties.revenue;
        const shipping = obj.properties.shipping;
        if (revenue && shipping) {
            obj.properties.revenue = revenue + shipping;
        }
        delete obj.properties.order_id;
    } catch (e) {
        console.log(e);
    } finally {
        next(payload);
    }
};

const getMiddlewareDefinitions = () => {
    return [{ targetIntegration: 'Facebook Pixel', middlewares: [facebookRevenueCalculationMiddleware] }];
};

module.exports = {
    getDestinationMiddlewares: getMiddlewareDefinitions
};
